  export const HEALTH_GATEWAY_URL ="https://www.healthgateway.gov.bc.ca/"
